import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "/images/wayside-logo-horizontal.png";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-maple-dark text-white" data-testid="footer">
            {/* Large text watermark */}
            <div className="overflow-hidden py-16">
                <p className="text-[12vw] leading-none font-anton text-white/5 whitespace-nowrap select-none">
                    WAYSIDE MAPLE • EST 2009 • TROY PA •
                </p>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 pb-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
                    {/* Logo & Description */}
                    <div className="md:col-span-2">
                        <Link to="/" data-testid="footer-logo">
                            <img 
                                src={LOGO_URL} 
                                alt="Wayside Maple" 
                                className="h-12 w-auto object-contain brightness-0 invert mb-6"
                            />
                        </Link>
                        <p className="text-white/60 text-sm leading-relaxed max-w-md">
                            Handcrafted maple syrup from the hills of Troy, Pennsylvania. 
                            Established in 2009, we're dedicated to producing the finest 
                            quality maple products using traditional methods.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-anton text-lg mb-6 text-white">Quick Links</h4>
                        <nav className="flex flex-col gap-3">
                            <Link to="/shop" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-shop">
                                Shop
                            </Link>
                            <Link to="/about" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-about">
                                About Us
                            </Link>
                            <Link to="/contact" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-contact">
                                Contact
                            </Link>
                        </nav>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-anton text-lg mb-6 text-white">Contact</h4>
                        <div className="flex flex-col gap-3 text-white/60 text-sm">
                            <p>Troy, Pennsylvania</p>
                            <p>United States</p>
                            <a href="mailto:info@waysidemaplefarm.com" className="hover:text-maple-red transition-colors">
                                info@waysidemaplefarm.com
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-white/40 text-sm font-mono">
                        © {currentYear} Wayside Maple. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        <Link to="/admin" className="text-white/40 hover:text-white/60 text-xs transition-colors" data-testid="footer-admin">
                            Admin
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
